/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrickData
 */
export interface BrickData {
    /**
     * Beschreibung des Steins
     * @type {string}
     * @memberof BrickData
     */
    description: string;
    /**
     * Ist geschützt?
     * @type {boolean}
     * @memberof BrickData
     */
    _protected: boolean;
    /**
     * Details zum Schutz
     * @type {string}
     * @memberof BrickData
     */
    protectionDetails: string;
    /**
     * Geschmacksmuster-Nummer
     * @type {string}
     * @memberof BrickData
     */
    gmNumber?: string;
    /**
     * Anmeldedatum
     * @type {Date}
     * @memberof BrickData
     */
    filingDate?: Date;
    /**
     * Registrierungsdatum
     * @type {Date}
     * @memberof BrickData
     */
    registrationDate?: Date;
    /**
     * Ablaufdatum
     * @type {Date}
     * @memberof BrickData
     */
    expiryDate?: Date;
    /**
     * Schutzstatus
     * @type {string}
     * @memberof BrickData
     */
    status?: BrickDataStatusEnum;
}


/**
 * @export
 */
export const BrickDataStatusEnum = {
    Active: 'active',
    Expired: 'expired',
    PublicDomain: 'public-domain',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type BrickDataStatusEnum = typeof BrickDataStatusEnum[keyof typeof BrickDataStatusEnum];


/**
 * Check if a given object implements the BrickData interface.
 */
export function instanceOfBrickData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "_protected" in value;
    isInstance = isInstance && "protectionDetails" in value;

    return isInstance;
}

export function BrickDataFromJSON(json: any): BrickData {
    return BrickDataFromJSONTyped(json, false);
}

export function BrickDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrickData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': json['description'],
        '_protected': json['protected'],
        'protectionDetails': json['protectionDetails'],
        'gmNumber': !exists(json, 'gmNumber') ? undefined : json['gmNumber'],
        'filingDate': !exists(json, 'filingDate') ? undefined : (new Date(json['filingDate'])),
        'registrationDate': !exists(json, 'registrationDate') ? undefined : (new Date(json['registrationDate'])),
        'expiryDate': !exists(json, 'expiryDate') ? undefined : (new Date(json['expiryDate'])),
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function BrickDataToJSON(value?: BrickData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'protected': value._protected,
        'protectionDetails': value.protectionDetails,
        'gmNumber': value.gmNumber,
        'filingDate': value.filingDate === undefined ? undefined : (value.filingDate.toISOString().substring(0,10)),
        'registrationDate': value.registrationDate === undefined ? undefined : (value.registrationDate.toISOString().substring(0,10)),
        'expiryDate': value.expiryDate === undefined ? undefined : (value.expiryDate.toISOString().substring(0,10)),
        'status': value.status,
    };
}

